// import IconButtonActions from './IconButtonActions';
// import { CustomColumn } from '../../types/customColumn';

// const DataTableBody = ({ page, prepareRow, columns, actions }: any) => (
//   <tbody>
//     {page.map((row: any) => {
//       prepareRow(row);
//       return (
//         <tr {...row.getRowProps()} className="dark:border-gray-700 border-b">
//           {row.cells.map((cell: any) => {
//             const column = cell.column;
//             return (
//               <td
//                 {...cell.getCellProps()}
//                 className="text-gray-900 dark:text-gray-200 px-4 py-2 text-sm"
//               >
//                 {'customCell' in column && (column as CustomColumn<object>).customCell
//                   ? (column as CustomColumn<object>).customCell(cell)
//                   : cell.render('Cell')}
//               </td>
//             );
//           })}
//           {actions && (
//             <td className="px-4 py-2 text-center">
//               <div className="flex justify-center">
//                 <IconButtonActions actions={actions} row={row.original} />
//               </div>
//             </td>
//           )}
//         </tr>
//       );
//     })}
//   </tbody>
// );

// export default DataTableBody;

import IconButtonActions from './IconButtonActions';
import { CustomColumn } from '../../types/customColumn';

const DataTableBody = ({ page, prepareRow, columns, actions }: any) => (
  <tbody>
    {page.map((row: any) => {
      prepareRow(row);

      // ✅ Extraemos la key
      const { key: rowKey, ...rowProps } = row.getRowProps();

      return (
        <tr key={rowKey} {...rowProps} className="dark:border-gray-700 border-b">
          {row.cells.map((cell: any) => {
            const column = cell.column;

            // ✅ key del cell
            const { key: cellKey, ...cellProps } = cell.getCellProps();

            return (
              <td
                key={cellKey}
                {...cellProps}
                className="text-gray-900 dark:text-gray-200 px-4 py-2 text-sm"
              >
                {'customCell' in column && (column as CustomColumn<object>).customCell
                  ? (column as CustomColumn<object>).customCell(cell)
                  : cell.render('Cell')}
              </td>
            );
          })}

          {actions && (
            <td className="px-4 py-2 text-center">
              <div className="flex justify-center">
                <IconButtonActions actions={actions} row={row.original} />
              </div>
            </td>
          )}
        </tr>
      );
    })}
  </tbody>
);

export default DataTableBody;
